module.exports = __webpack_public_path__ + "static/img/solu4.dbb9c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Solution/img/solu4.jpg
// module id = NSwn
// module chunks = 1